import { useEffect, useState } from "react";
import { fetchPriceCheckDetails } from "../../service";
import Label from "../../common/Label";

const YourPostcodeDetails = ({ isHome = false }) => {
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);

    useEffect(() => {
        const getPriceCheckDetails = async () => {
            try {
                const res = await fetchPriceCheckDetails("YOUR_POSTCODE");
                if (res?.status === "Success") {
                    setDetails(res.price_check_details || []);
                }
            } catch (error) {
                console.error("Error fetching price check details:", error);
            } finally {
                setLoading(false);
            }
        };
        
        getPriceCheckDetails();
    }, []);

    if (loading) return null;

    return (
        <div className={`mt-4`}>
            {details.map((item, index) => (
                <>
                    {item.price_check_detail_name !== null ? (
                        <div className={`card card-frame ${!isHome && 'mx-3 job-card-bg-color'} mb-3`} key={index}>
                            <div className="card-body">
                                <Label text={item.price_check_detail_name} />

                                <ul className="mt-2 mb-0 text-sm text-muted">
                                    {item.price_check_points?.map((point, idx) => (
                                        <li key={idx}>{point.price_check_point_description}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <>
                            {item.price_check_points?.map((point, idx) => (
                                <p className="text-md mx-3 text-muted" key={idx}>
                                    {point.price_check_point_description}
                                </p>
                            ))}
                        </>
                    )}
                </>
            ))}
        </div>
    );
};

export default YourPostcodeDetails;